/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ActorInputs */

const en_actor = /** @type {(inputs: ActorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actor`)
};

const es_actor = /** @type {(inputs: ActorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actor`)
};

const fr_actor = /** @type {(inputs: ActorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acteur`)
};

const de_actor = /** @type {(inputs: ActorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akteur`)
};

const id_actor = /** @type {(inputs: ActorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktor`)
};

/** @type {(inputs: ActorInputs) => LocalizedString} */
const ja_actor = en_actor;

/** @type {(inputs: ActorInputs) => LocalizedString} */
const zh_actor = en_actor;

/** @type {(inputs: ActorInputs) => LocalizedString} */
const ar_actor = en_actor;

/** @type {(inputs: ActorInputs) => LocalizedString} */
const it_actor = en_actor;

/** @type {(inputs: ActorInputs) => LocalizedString} */
const ru_actor = en_actor;

/** @type {(inputs: ActorInputs) => LocalizedString} */
const pt_actor = en_actor;

/** @type {(inputs: ActorInputs) => LocalizedString} */
const ko_actor = en_actor;

/**
* | output |
* | --- |
* | "Actor" |
*
* @param {ActorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const actor = /** @type {((inputs?: ActorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ActorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actor(inputs)
	if (locale === "es") return es_actor(inputs)
	if (locale === "fr") return fr_actor(inputs)
	if (locale === "de") return de_actor(inputs)
	if (locale === "ja") return ja_actor(inputs)
	if (locale === "zh") return zh_actor(inputs)
	if (locale === "ar") return ar_actor(inputs)
	if (locale === "id") return id_actor(inputs)
	if (locale === "it") return it_actor(inputs)
	if (locale === "ru") return ru_actor(inputs)
	if (locale === "pt") return pt_actor(inputs)
	return ko_actor(inputs)
});